import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// import { useFetch } from '../../hooks/CustomHooks';
// import urls from '../../config/Config';
import { AiOutlineAppstore, AiOutlineEye } from 'react-icons/ai';
import { GrCatalogOption, GrPhone, GrImage } from 'react-icons/gr';
import { TiMessages } from 'react-icons/ti';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { IoSettingsOutline } from 'react-icons/io5';
import { GiMoneyStack } from 'react-icons/gi';
import { BsArrowRightCircle, BsArrowLeftCircle } from 'react-icons/bs';
import { TbLogout } from 'react-icons/tb';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { toggleSidenav } from '../../redux/actions/uiActions';
import { KeyOutlined } from '@ant-design/icons';

import './sidemenu.style.scss';
import { logout } from '../../redux/actions/authActions';

const Sidenav = (props) => {
  // const [navs] = useFetch(urls.urls.sideNav);
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui.ui);
  const location = useLocation();
  const handleLogout = () => {
    dispatch(logout());
  };

  const navs = [
    {
      label: 'Dashboard',
      icon: <AiOutlineAppstore />,
      link: '/',
    },
    {
      label: 'Manage Catalogue',
      icon: <GrCatalogOption />,
      link: '/manage-catelog',
    },
    {
      label: 'Keyword Mapping',
      icon: <KeyOutlined />,
      link: '/keyword-mapping',
    },
    {
      label: 'Manage Leads',
      icon: <TiMessages />,
      link: '/manage-leads',
    },
    {
      label: 'Lead Manager',
      icon: <HiOutlineUserGroup />,
      link: '/buy_leads',
    },
    {
      label: 'Catalogue Views',
      icon: <AiOutlineEye />,
      link: '/catelog-views',
    },
    {
      label: 'Video Tutorials',
      icon: <GrImage />,
      link: '/video-tutorial',
    },
    {
      label: 'Paid Services',
      icon: <GiMoneyStack />,
      link: '/paid_service_plans',
    },
    {
      label: 'Support',
      icon: <GrPhone />,
      link: '/support',
    },
    {
      label: 'Settings',
      icon: <IoSettingsOutline />,
      link: '/settings',
    },
  ];

  const handleTogle = () => {
    dispatch(toggleSidenav());
  };

  return (
    <div className='side-nav'>
      <button className='toggle-switch' onClick={handleTogle}>
        {ui.toggleSideMenu ? (
          <BsArrowRightCircle size={22} />
        ) : (
          <BsArrowLeftCircle size={22} />
        )}
      </button>
      <ul className={`side-menu ${ui.toggleSideMenu ? 'text-center' : ''}`}>
        {navs.map((item, i) => {
          return (
            <li key={`menu-li-${i}`}>
              <div>
                <NavLink
                  to={item.link}
                  className={
                    location.pathname === item.link ||
                    (item.link !== '/' &&
                      location.pathname.startsWith(item.link))
                      ? 'active'
                      : ''
                  }
                >
                  <span
                    className={[
                      'icons',
                      ui.toggleSideMenu ? ' icons__center' : '',
                    ].join('')}
                  >
                    {item.icon}
                  </span>
                  {!ui.toggleSideMenu ? <>{item.label}</> : <></>}
                </NavLink>
              </div>
            </li>
          );
        })}
        <li>
          <div className='logout__button'>
            <button onClick={handleLogout}>
              <span
                className={[
                  'icons',
                  ui.toggleSideMenu ? ' icons__center' : '',
                ].join('')}
              >
                {' '}
                <TbLogout />{' '}
              </span>
              {!ui.toggleSideMenu ? 'Logout' : ''}
            </button>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Sidenav;
